import AbstractNormalizersResolver from "../../core/AbstractNormalizersResolver";
import ClickSearchCategoryNormalizer from "./ClickSearchCategoryNormalizer";
export default class ClickSearchCategoryNormalizersResolver extends AbstractNormalizersResolver {
    register() {
        return [
            new ClickSearchCategoryNormalizer(),
        ];
    }
}
